import React from 'react';

function ChatInput({ input, setInput, loading, handleSubmit }) {
    return (
        <div className='d-flex flex-row w-100'>
            <form onSubmit={handleSubmit} className='d-flex w-100'>
                <input
                    className='form-control border border-secondary py-4 bg-ececec'
                    placeholder='Type a message...'
                    value={input}
                    onChange={e => setInput(e.target.value)}
                    disabled={loading}
                />
                <button
                    className='btn btn-primary px-4'
                    disabled={loading}
                >
                    Send
                </button>
            </form>
        </div>
    );
}

export default ChatInput;
